import React from 'react';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Button from '@amzn/awsui-components-react/polaris/button';
import { useTranslation } from 'react-i18next';

export interface CancelSignupModalProps {
  visible: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function CancelSignupModal({ visible, onConfirm, onDismiss }: CancelSignupModalProps) {
  const { t } = useTranslation('signup');

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t('cancelSignupModal.title')}
      closeAriaLabel={t('cancelSignupModal.dismiss')}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              {t('cancelSignupModal.dismiss')}
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              {t('cancelSignupModal.confirm')}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {t('cancelSignupModal.message')}
    </Modal>
  );
}
